import React from "react";

import Container from "@mui/material/Container";

function HomePage() {
  return <Container maxWidth="sm">HOME</Container>;
}

export default HomePage;
